/* eslint-disable spire/export-styles */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { useMergeStyles } from "@insite/content-library/additionalStyles";
import { ContentWrapper } from "@insite/content-library/Widgets/Basic/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Hidden from "@insite/mobius/Hidden";
import { LinkProps } from "@insite/mobius/Link";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import injectCss from "@insite/mobius/utilities/injectCss";
import TextAutoSlider from "@NA/Components/ADITextSlider";
import toggleLoginDrawer from "@NA/Handlers/ADILoginDrawerHandler";
import toggleRewardsDrawer from "@NA/Handlers/ADIRewardsDrawerHandler";
import convertHtmlToObjectValues from "@NA/Utils/Utility";
import React, { FC, useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";
import styled, { css } from "styled-components";
const enum fields {
    backgroundColor = "backgroundColor",
    topBannerTextFeild = "topBannerTextFeild",
    color = "color",
    interval = "interval",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.backgroundColor]: string;
        [fields.topBannerTextFeild]: string;
        [fields.color]: string;
        [fields.interval]: number;
    };
}

const mapStateToProps = (state: ApplicationState) => ({
    enableWarehousePickup: getSettingsCollection(state).accountSettings.enableWarehousePickup,
    session: state.context.session,
});

const mapDispatchToProps = {
    toggleLoginDrawer,
    toggleRewardsDrawer
};
type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const Navigation = styled.div<{ $background?: string }>`
    color: ${getColor("primary.contrast")};
    font-size: 14px;
    min-height: 35px;
    background-color: ${props => (props.$background != "" ? props.$background : "#2380A3")};
    display: flex;
    justify-content: flex-end;
    align-items: center;
    ${({ theme }: { theme: BaseTheme }) =>
        breakpointMediaQueries(theme, [
            css`
                min-height: 25px;
            `,
            css`
                min-height: 25px;
            `,
            css`
                min-height: 25px;
            `,
            null,
            null,
        ])}
`;

const NavItem = styled.span<InjectableCss>`
    display: inline-flex;

    > span,
    > a {
        margin-left: 10px;
    }
    ${injectCss}
`;

export interface SecondaryNavigationStyles {
    wrapper?: InjectableCss;
    innerWrapper?: InjectableCss;
    leftSide?: InjectableCss;
    rightSide?: InjectableCss;
    rightSideLink?: InjectableCss;
    signInLink?: InjectableCss;
    styledLink?: LinkProps;
}

export const secondaryNavigationStyles: SecondaryNavigationStyles = {
    wrapper: {
        css: css`
            width: 1470px;
            margin: 0 auto;
            height: 100%;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            width: 100%;
                        `,
                    ],
                    "max",
                )}
        `,
    },
    innerWrapper: {
        css: css`
            display: flex;
            width: 100%;
            height: 100%;
        `,
    },

    leftSide: {
        css: css`
            width: auto;
            flex: 1;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: 100%;
                        margin-left: 0px !important;
                    `,
                    css`
                        width: 100%;
                        margin-left: 0px !important;
                    `,
                    css`
                        width: 65%;
                        margin-left: 0px !important;
                    `,
                    css`
                        width: 75%;
                    `,
                    null,
                ])}
            > div[class^="Wrapper"] {
                ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    null,
                    null,
                    css`
                            margin-left: 263px;
                        `,
                ])}
                div[class^="ContentWrapper"] {
                    height: 100%;
                    padding: 8px 0 8px;
                    background: transparent;
                    text-align: center;
                    color: #fff;
                    clear: both;
                    max-height: 100%;
                    overflow: hidden;
                    height: auto;
                    font-size: 14px;
                    font-weight: 600;
                    line-height: normal;
                }
                strong {
                    font-size: 14px;
                    padding: 0 15px;
                    margin: 0 auto;
                    color: ${getColor("primary.contrast")} !important;
                    height: 100%;
                    font-weight: 600;
                    ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    null,
                    null,
                    css`
                                text-align: center;
                            `,
                ])}

                    span {
                        text-decoration: underline;
                        color: ${getColor("primary.contrast")} !important;
                    }
                }
            }
        `,
    },
    rightSide: {
        css: css`
            display: flex;
            justify-content: flex-end;
            align-items: center;
            width: auto;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`
                        width: 35%;
                    `,
                    css`
                        width: 25%;
                    `,
                    null,
                ])}
        `,
    },
    rightSideLink: {
        css: css`
            span {
                font-size: 12px;
                padding-right: 15px;
                font-weight: 600;
                display: inline-block;
                margin-bottom: 4px;
                color: ${getColor("primary.contrast")} !important;
                &:hover {
                    text-decoration: underline;
                }
            }
        `,
    },

    signInLink: {
        css: css`
            flex: 0 0 auto;
        `,
    },
    styledLink: {
        css: css`
            text-decoration: underline;
            > span {
                color: ${getColor("primary.contrast")} !important;
            }
        `,
    },
};

const SecondaryNavigation: FC<Props> = ({
    id,
    session,
    toggleLoginDrawer,
    toggleRewardsDrawer,
    fields: { backgroundColor, topBannerTextFeild, color, interval },
}) => {
    const styles = useMergeStyles("secondaryNavigation", secondaryNavigationStyles);
    const topBannerSliderData = convertHtmlToObjectValues(topBannerTextFeild);
    const isAuthenticated = (session.isAuthenticated || session.rememberMe) && !session.isGuest;
    const setMarginLeft = () => {
        const rightSection = document.querySelector<HTMLElement>(".right-section");
        const leftSection = document.querySelector<HTMLElement>(".left-section");
        if (rightSection && leftSection) {
            const topLinksWidth = rightSection.offsetWidth;
            leftSection.style.marginLeft = `${topLinksWidth}px`;
        }
    };

    useEffect(() => {
        setMarginLeft();
        window.addEventListener("resize", setMarginLeft);
    }, []);

    return (
        <Navigation $background={backgroundColor}>
            <StyledWrapper {...styles.wrapper}>
                <StyledWrapper {...styles.innerWrapper}>
                    <NavItem {...styles.leftSide} className="left-section">
                        <TextAutoSlider textList={topBannerSliderData} color={color} interval={interval} toggleLoginDrawer={toggleLoginDrawer} toggleRewardsDrawer={toggleRewardsDrawer}/>
                    </NavItem>
                    <Hidden below="md" {...styles.rightSide} className="right-section">
                        {!isAuthenticated ? (
                            <NavItem {...styles.rightSideLink}>
                                <Zone zoneName="BecomeACustomer" contentId={id} />
                            </NavItem>
                        ) : (
                            <NavItem {...styles.rightSideLink}>
                                <Zone zoneName="RequestAQuote" contentId={id} />
                            </NavItem>
                        )}
                        <NavItem {...styles.rightSideLink}>
                            <Zone zoneName="BranchLocator" contentId={id} />
                        </NavItem>
                        <NavItem {...styles.rightSideLink}>
                            <Zone zoneName="Help" contentId={id} />
                        </NavItem>
                    </Hidden>
                </StyledWrapper>
            </StyledWrapper>
        </Navigation>
    );
};

const secondaryNavigation: WidgetModule = {
    component: connect(mapStateToProps)(SecondaryNavigation),
    definition: {
        group: "Common",
        icon: "NavigationList",
        fieldDefinitions: [
            {
                name: fields.backgroundColor,
                editorTemplate: "ColorPickerField",
                displayName: "Background Color",
                defaultValue: "#2380A3",
                fieldType: "General",
            },
            {
                name: fields.color,
                editorTemplate: "ColorPickerField",
                displayName: "Text Color",
                defaultValue: "#fff",
                fieldType: "General",
            },
            {
                name: fields.topBannerTextFeild,
                displayName: "Rotate Banner Content",
                editorTemplate: "RichTextField",
                defaultValue: "",
                fieldType: "General",
                tooltip: "You can add customized banner content.",
                placeholder: "text placeholder",
                isRequired: true,
            },
            {
                name: fields.interval,
                displayName: "Interval",
                editorTemplate: "IntegerField",
                defaultValue: 5000,
                fieldType: "General",
                tooltip: "Add slider interval (1000 = 1 sec)",
                placeholder: "Please enter slider interval",
            },
        ],
    },
};

export default secondaryNavigation;
